
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: {
                "data": {
                    },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台通过车牌查看月票预约信息详情",
                t_url: this.commonUrls.test+"getMonthTicketBillDetail",
                p_url: this.commonUrls.prod+"getMonthTicketBillDetail",
                precondition: "无",
                fitSystem: "云停车场,传统VEMS车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方流水号' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票流水id' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '月票订单流水' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '支付流水' },
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方支付流水' },
                        { info1: 'billType', info2: '是', info3: 'Integer', info4: '流水类型（0开通，1续期，2退款）' },
                        { info1: 'totalValue', info2: '是', info3: 'Decimal', info4: '原价' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '折扣价' },
                        { info1: 'refundValue', info2: '是', info3: 'Decimal', info4: '退款金额' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式' },
                        { info1: 'payModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' },
                        { info1: 'updateBy', info2: '是', info3: 'String', info4: '最新操作人' },

					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketBillDetail.vue